import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import { useEffect, useState } from "react";
import { getNotFoundErrorURL, getSystemErrorURL } from "../bookshelfLinks.ts";
import { DeweySchema } from "./helpers/brandSchema.ts";
import { noticeError } from "../../common/api/monitoring/index.ts";
import FullScreenIframe from "../../common/core-ui/FullScreenIframe.tsx";
import { useIntl } from "react-intl";
import { loadBrandOnce } from "./rootLoader.ts";

function goTo404Error(brand?: DeweySchema) {
  const baseParams = brand
    ? { locale: brand.locale, theme: brand.Theme.primary }
    : {};

  // 404 page back button should not take you back to a non-existent page,
  // as that would just loop back to the error again
  window.location.replace(
    getNotFoundErrorURL({
      ...baseParams,
      missingURL: window.location.href,
    })
  );
}

export default function RootErrorBoundary() {
  const intl = useIntl();
  const error = useRouteError();
  const [brandData, setBrandData] = useState<DeweySchema>();
  const [showInlineError, setShowInlineError] = useState(false);

  useEffect(() => {
    if (error instanceof Error) {
      noticeError(error);
    }
  }, [error]);

  useEffect(() => {
    void loadBrandOnce()
      .catch(() => {
        // That's ok, just don't use brand data
        return undefined;
      })
      .then((brand) => {
        setBrandData(brand);
        if (isRouteErrorResponse(error) && error.status === 404) {
          goTo404Error(brand);
        } else {
          setShowInlineError(true);
        }
      });
  }, [error]);

  if (showInlineError) {
    return (
      <FullScreenIframe
        url={getSystemErrorURL({ locale: brandData?.locale ?? "en" })}
        title={intl.formatMessage({ defaultMessage: "System Error" })}
      />
    );
  }
}
